import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { mockData } from '../data/mock';

// Barre d'action fixe en bas, visible uniquement sur mobile :
// click-to-call (numéro du cabinet) + WhatsApp.
export const MobileCallBar = () => (
  <div
    className="md:hidden fixed bottom-0 left-0 right-0 z-[60] flex shadow-[0_-4px_20px_rgba(0,0,0,0.18)]"
    data-testid="mobile-call-bar"
  >
    <a
      href="tel:+33482530684"
      data-testid="mobile-call-button"
      className="flex-1 flex items-center justify-center gap-2 bg-primary-blue text-white py-4 text-base font-medium active:bg-secondary-blue"
    >
      <Phone className="w-5 h-5" />
      Appeler
    </a>
    <a
      href={`https://wa.me/${mockData.cabinet.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-whatsapp-button"
      className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] text-white py-4 text-base font-medium active:bg-[#1eb858]"
    >
      <MessageCircle className="w-5 h-5" />
      WhatsApp
    </a>
  </div>
);
